var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"sidebar"},[_c('p',[_vm._v("인기 있는 태그")]),_c('div',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag,index){return _c('VTag',{key:index,attrs:{"tag":tag}})}),1)])])}
var staticRenderFns = []

export { render, staticRenderFns }